import { useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

export const AppHeader = ({ to = "/dashboard" }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const name = user?.firmenname || user?.ansprechpartner || "";

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <header className="sticky top-0 z-40 bg-cream/95 backdrop-blur border-b border-sand">
      <div className="max-w-6xl mx-auto px-6 h-20 flex items-center justify-between">
        <Logo size={48} to={to} />
        <div className="flex items-center gap-5">
          <span className="hidden sm:inline text-sm text-charcoal/70" data-testid="header-username">
            {name}
          </span>
          <Button
            variant="ghost"
            onClick={handleLogout}
            className="text-charcoal hover:text-gold gap-2"
            data-testid="logout-button"
          >
            <LogOut className="w-4 h-4" strokeWidth={1.5} />
            Logout
          </Button>
        </div>
      </div>
    </header>
  );
};
